import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Button, Form, Modal } from "semantic-ui-react";
import {
  addAdminOrganization,
  createLicensesOrganization,
  getLicensesOrganization,
  updateLicensesOrganization,
} from "../../../../assets/api";
import ButtonSubmit from "../../../../components/Field/components/ButtonSubmit";
import Field from "../../../../components/Field/Field";
import { AuthContext } from "../../../../context/AuthContext";
import { useForm } from "../../../../hooks/useForm";
interface Props {
  isVisible: boolean;
  onClose: () => void;
  organizationCode: string;
  onSubmit: Function;
}

const ModalUpdateNumLicenses = (props: Props) => {
  const { t } = useTranslation();
  const [form, setForm, handleInputChange] = useForm({
    licenses: "",
  });
  const [currentLicenses, setCurrentLicenses] = useState(0);

  const authContext = useContext(AuthContext);
  const token = authContext.account.access_token;
  useEffect(() => {
    (async () => {
      const licensesOrganizations: any[] = await getLicensesOrganization(token)
      .then(response => response.json())
      .then(response => response["Value"]);

      const licenseInfo = licensesOrganizations.find( (license: any) => license.key.split("-")[1] === props.organizationCode)

      const numLicenses = licenseInfo ? parseInt(licenseInfo.value) : -1;
      setCurrentLicenses(numLicenses);
    })();
  }, [props.isVisible]);

  const formFormated = Object.entries(form).map(([key, value]) => ({
    key,
    value,
    format: "number",
    required: true,
  }));
  return (
    <Modal
      id={"modal-add-admin-organization"}
      size={"mini"}
      open={props.isVisible}
      onClose={props.onClose}
    >
      <Modal.Header>
        {t(`administration.update_licenses_organization.title`)}
      </Modal.Header>
      <Modal.Content>
        <Form className="border-0" style={{ boxShadow: "none" }}>
          {formFormated.map((_: any) => {
            return (
              <Field
                format={_.format}
                required={_.required}
                label={_.label}
                title={t(
                  `administration.update_licenses_organization.form.${_.key}`
                )}
                name={_.key}
                value={_.value}
                onChange={handleInputChange}
                textError={t(
                  `administration.update_licenses_organization.form.${_.key}_error`
                )}
              />
            );
          })}
        </Form>
        <p>
          {t("administration.update_licenses_organization.current_licenses", {
            licenses: currentLicenses >= 0 ? currentLicenses : 0,
          })}
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button
          onClick={() => {
            props.onClose();
          }}
          style={{ backgroundColor: "#cfe1ff" }}
        >
          {t("btn.cancel")}
        </Button>
        <ButtonSubmit
          title={t(
            "administration.update_licenses_organization.buttons.submit"
          )}
          form={formFormated}
          handleSubmit={async () => {
            const newForm = {
              key: `Licenses/Max-${props.organizationCode}`,
              value: form.licenses,
            };
            try {
              let response;
              if (currentLicenses >= 0) {
                response = await updateLicensesOrganization(newForm, token);
              } else {
                response = await createLicensesOrganization(newForm, token);
              }
              if (!response.ok) throw new Error("Bad Response");
              toast((
                t("administration.update_licenses_organization.success")
              ), { type: "success"});
              props.onSubmit();
              props.onClose();
            } catch (error) {
              toast(
                t("administration.update_licenses_organization.error"), { type: "error"}
              );
            }
          }}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default ModalUpdateNumLicenses;